"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const redux_1 = require("redux");
const utils_1 = require("../utils");
const typesSession = require("../session/types");
const types = require("./types");
// eslint-disable-next-line @rushstack/typedef-var
const errorMessage = utils_1.createReducer(immutable_1.Map())({
    [types.FETCH_REQUEST]: (state, action) => state.set(action.objectType, null),
    [types.FETCH_FAILURE]: (state, action) => state.set(action.objectType, action.errorMessage),
    [types.FETCH_SUCCESS]: (state, action) => state.set(action.objectType, null),
    [types.SAVE_REQUEST]: (state, action) => state.set(`${action.objectType}:${action.objectId}`, null),
    [types.SAVE_FAILURE]: (state, action) => state.set(`${action.objectType}:${action.objectId}`, action.errorMessage),
    [types.SAVE_SUCCESS]: (state, action) => state.set(`${action.objectType}:${action.objectId}`, null),
    [types.FETCHONE_REQUEST]: (state, action) => state.set(`${action.objectType}:${action.objectId}`, null),
    [types.FETCHONE_FAILURE]: (state, action) => state.set(`${action.objectType}:${action.objectId}`, action.errorMessage),
    [types.FETCHONE_SUCCESS]: (state, action) => state.set(`${action.objectType}:${action.objectId}`, null),
    [types.CUSTOM_REQUEST]: (state, action) => action.statePath ? state.set(action.statePath, null) : state,
    [types.CUSTOM_FAILURE]: (state, action) => action.statePath ? state.set(action.statePath, action.errorMessage) : state,
    [types.CUSTOM_SUCCESS]: (state, action) => action.statePath ? state.set(action.statePath, null) : state
});
// eslint-disable-next-line @rushstack/typedef-var
const isProcessing = utils_1.createReducer(immutable_1.Map())({
    [types.FETCH_REQUEST]: (state, action) => state.set(action.objectType, true),
    [types.FETCH_FAILURE]: (state, action) => state.set(action.objectType, false),
    [types.FETCH_SUCCESS]: (state, action) => state.set(action.objectType, false),
    [types.SAVE_REQUEST]: (state, action) => state.set(`${action.objectType}:item`, true),
    [types.SAVE_FAILURE]: (state, action) => state.set(`${action.objectType}:item`, false),
    [types.SAVE_SUCCESS]: (state, action) => state.set(`${action.objectType}:item`, false),
    [types.FETCHONE_REQUEST]: (state, action) => state.set(`${action.objectType}:${action.objectId}`, true),
    [types.FETCHONE_FAILURE]: (state, action) => state.set(`${action.objectType}:${action.objectId}`, false),
    [types.FETCHONE_SUCCESS]: (state, action) => state.set(`${action.objectType}:${action.objectId}`, false),
    [types.CUSTOM_REQUEST]: (state, action) => action.statePath ? state.set(action.statePath, true) : state,
    [types.CUSTOM_FAILURE]: (state, action) => action.statePath ? state.set(action.statePath, false) : state,
    [types.CUSTOM_SUCCESS]: (state, action) => action.statePath ? state.set(action.statePath, false) : state
});
const createObjectKey = (workspaceId, objectType, objectId) => `${workspaceId}:${objectType}:${objectId}`;
// eslint-disable-next-line @rushstack/typedef-var
const entitiesById = utils_1.createReducer(immutable_1.Map())({
    [types.FETCH_SUCCESS]: (state, action) => {
        const data = {};
        action.items.forEach((item) => {
            data[createObjectKey(action.workspaceId, action.objectType, item.id)] = item;
        });
        return state.merge(immutable_1.Map(data));
    },
    [types.FETCHONE_SUCCESS]: (state, action) => {
        return state.set(createObjectKey(action.workspaceId, action.objectType, action.objectId), action.item);
    },
    [types.SAVE_SUCCESS]: (state, action) => {
        return state.set(createObjectKey(action.workspaceId, action.objectType, action.item.id), action.item);
    },
    [types.CUSTOM_SUCCESS]: (state, action) => {
        if (!action.reducers && action.reducers.entitiesByIdReducer) {
            return state;
        }
        return action.reducers.entitiesByIdReducer(state, action.workspaceId, action.data);
    },
    [typesSession.LOGOUT_SUCCESS]: () => immutable_1.Map()
});
// eslint-disable-next-line @rushstack/typedef-var
const items = utils_1.createReducer(immutable_1.Map())({
    [types.FETCH_SUCCESS]: (state, action) => state.set(`${action.workspaceId}:${action.objectType}`, action.items.map((i) => i.id)),
    [types.SAVE_SUCCESS]: (state, action) => {
        const workspaceId = action.workspaceId;
        const indexName = `${workspaceId}:${action.objectType}`;
        const itemId = action.item.id;
        if (state.has(indexName)) {
            if (state.get(indexName).indexOf(itemId) >= 0) {
                return state;
            }
            return state.set(indexName, [...state.get(indexName), itemId]);
        }
        else {
            return state.set(indexName, [itemId]);
        }
    },
    [typesSession.LOGOUT_SUCCESS]: () => immutable_1.Map()
});
// eslint-disable-next-line @rushstack/typedef-var
const metadata = utils_1.createReducer(immutable_1.Map())({
    [types.FETCH_SUCCESS]: (state, action) => state.set(action.objectType, action.metadata || {}),
    [typesSession.LOGOUT_SUCCESS]: () => immutable_1.Map()
});
exports.default = redux_1.combineReducers({
    errorMessage,
    isProcessing,
    entitiesById,
    items,
    metadata
});
//# sourceMappingURL=reducers.js.map